"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const Utils_1 = require("../../../../utils/Utils");
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
const bs_1 = require("react-icons/bs");
const CustomPagination_1 = require("../../../Common/CustomPagination");
const notification_api_1 = require("../../../../utils/api/notification/notification.api");
const UseCrudNotification_1 = require("../requestForm/UseCrudNotification");
const EmptyAlert_1 = __importDefault(require("../../../Shared/Alerts/EmptyAlert"));
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const theme_1 = require("../../../../utils/theme");
const react_switch_1 = __importDefault(require("react-switch"));
const react_medium_image_zoom_1 = __importDefault(require("react-medium-image-zoom"));
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const ShowNotificationsModal_1 = __importDefault(require("../Modals/ShowNotificationsModal"));
const AddNotificationsModal_1 = __importDefault(require("../Modals/AddNotificationsModal"));
const DeleteNotificationButton = ({ id }) => {
    const onDelete = (0, UseCrudNotification_1.UseDeleteNotification)(id);
    return react_1.default.createElement(Dropdown_1.default.Item, { onClick: () => onDelete() }, "Supprimer");
};
const ShowNotificationButton = ({ item }) => {
    const [showNotificationModal, setShowNotificationModal] = (0, react_1.useState)(false);
    const handleShowNotificationModal = () => {
        setShowNotificationModal(true);
    };
    const handleCloseNotificationModal = () => {
        setShowNotificationModal(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_1.default.Item, { onClick: handleShowNotificationModal }, "Voir les d\u00E9tails"),
        react_1.default.createElement(ShowNotificationsModal_1.default, { show: showNotificationModal, handleClose: handleCloseNotificationModal, item: item })));
};
const EditNotificationButton = ({ item }) => {
    const [showEditNotificationModal, setShowEditNotificationModal] = (0, react_1.useState)(false);
    const handleShowEditNotificationModal = () => {
        setShowEditNotificationModal(true);
    };
    const handleCloseEditNotificationModal = () => {
        setShowEditNotificationModal(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_1.default.Item, { onClick: handleShowEditNotificationModal }, "Modifier"),
        react_1.default.createElement(AddNotificationsModal_1.default, { addNotifs: showEditNotificationModal, setAddNotifs: handleCloseEditNotificationModal, item: item })));
};
const NotificationsProgrammeesTable = ({ search, selectedCategory, dates, }) => {
    const [page, setPage] = (0, react_1.useState)(1);
    const [perPage, setPerPage] = (0, react_1.useState)(10);
    const { data = { data: [], count: 0 }, isLoading } = (0, notification_api_1.useGetNotificationsProgrammeesQuery)({});
    const filteredData = data.data.filter((item) => {
        var _a, _b, _c, _d, _e;
        const matchSearch = ((_a = item.content) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search.toLowerCase())) ||
            ((_b = item.segment) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(search.toLowerCase())) ||
            ((_c = item.scheduled_datetime) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(search.toLowerCase()));
        const matchCategory = selectedCategory
            ? ((_e = (_d = item.categorie) === null || _d === void 0 ? void 0 : _d.name) === null || _e === void 0 ? void 0 : _e.toLowerCase()) ===
                selectedCategory.toLowerCase()
            : true;
        const matchDate = dates.startDate && dates.endDate
            ? (() => {
                const scheduledDate = new Date(item.scheduled_datetime);
                return (scheduledDate >= dates.startDate &&
                    scheduledDate <= dates.endDate);
            })()
            : true;
        return matchSearch && matchCategory && matchDate;
    });
    const paginatedData = filteredData.slice((page - 1) * perPage, page * perPage);
    const [editData, { isError, error }] = (0, notification_api_1.useAddOrUpdateNotificationMutation)();
    const togglePublier = (item) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const data = {
            is_scheduled: item.is_scheduled === 1 ? 0 : 1,
            scheduled_datetime: new Date(),
            added_by: item === null || item === void 0 ? void 0 : item.added_by,
            categorie_id: item === null || item === void 0 ? void 0 : item.categorie_id,
            content: item === null || item === void 0 ? void 0 : item.content,
            direction_id: item === null || item === void 0 ? void 0 : item.direction_id,
            id: item === null || item === void 0 ? void 0 : item.id,
            is_sticked: item.is_sticked,
            media: item === null || item === void 0 ? void 0 : item.media,
            media_type: item === null || item === void 0 ? void 0 : item.media_type,
            segment: item === null || item === void 0 ? void 0 : item.segment,
            severity: item === null || item === void 0 ? void 0 : item.severity,
            slug: item === null || item === void 0 ? void 0 : item.slug,
            updated_at: item === null || item === void 0 ? void 0 : item.updated_at,
            _method: "PUT",
        };
        const action = data.is_scheduled === 0 ? "publier" : "retirer";
        const result = yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir ${action} cette notification ?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                try {
                    return yield editData({ id: item === null || item === void 0 ? void 0 : item.id, data });
                }
                catch (err) {
                    sweetalert2_1.default.showValidationMessage(((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message) ||
                        `Une erreur de statut ${(err === null || err === void 0 ? void 0 : err.status) || "inconnue"} est survenue`);
                    throw err;
                }
            }),
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        });
        if ((result === null || result === void 0 ? void 0 : result.isConfirmed) && ((_a = result === null || result === void 0 ? void 0 : result.value) === null || _a === void 0 ? void 0 : _a.data)) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `Notification ${result.value.data.data.is_scheduled === 0
                    ? "publiée"
                    : "retirée"} avec succès !`,
                iconColor: theme_1.Color.themeColor,
                showConfirmButton: false,
                timer: 1500,
            });
        }
    });
    const toggleArchiver = (item) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const data = {
            is_archive: item.is_archive === 1 ? 0 : 1,
            is_scheduled: item.is_scheduled,
            scheduled_datetime: item === null || item === void 0 ? void 0 : item.scheduled_datetime,
            added_by: item === null || item === void 0 ? void 0 : item.added_by,
            categorie_id: item === null || item === void 0 ? void 0 : item.categorie_id,
            content: item === null || item === void 0 ? void 0 : item.content,
            direction_id: item === null || item === void 0 ? void 0 : item.direction_id,
            id: item === null || item === void 0 ? void 0 : item.id,
            is_sticked: item.is_sticked,
            media: item === null || item === void 0 ? void 0 : item.media,
            media_type: item === null || item === void 0 ? void 0 : item.media_type,
            segment: item === null || item === void 0 ? void 0 : item.segment,
            severity: item === null || item === void 0 ? void 0 : item.severity,
            slug: item === null || item === void 0 ? void 0 : item.slug,
            updated_at: item === null || item === void 0 ? void 0 : item.updated_at,
            _method: "PUT",
        };
        const action = data.is_archive === 0 ? "désarchiver" : "archiver";
        const result = yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir ${action} cette notification ?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                try {
                    return yield editData({ id: item === null || item === void 0 ? void 0 : item.id, data });
                }
                catch (err) {
                    sweetalert2_1.default.showValidationMessage(((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message) ||
                        `Une erreur de statut ${(err === null || err === void 0 ? void 0 : err.status) || "inconnue"} est survenue`);
                    throw err;
                }
            }),
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        });
        if ((result === null || result === void 0 ? void 0 : result.isConfirmed) && ((_a = result === null || result === void 0 ? void 0 : result.value) === null || _a === void 0 ? void 0 : _a.data)) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `Notification ${result.value.data.data.is_archive === 0
                    ? "désarchiver"
                    : "archivée"} avec succès !`,
                iconColor: theme_1.Color.themeColor,
                showConfirmButton: false,
                timer: 1500,
            });
        }
    });
    const titreFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "formatter__wrapper" },
            react_1.default.createElement("div", { className: `d-flex gap-3 ${(row === null || row === void 0 ? void 0 : row.media_type) !== "image"
                    ? "flex-column align-items-start"
                    : "flex-row align-items-center"}` },
                (row === null || row === void 0 ? void 0 : row.media) && (row === null || row === void 0 ? void 0 : row.media_type) === "image" && (react_1.default.createElement("div", { className: "image__wrapper" },
                    react_1.default.createElement(react_medium_image_zoom_1.default, null,
                        react_1.default.createElement("img", { src: (0, Utils_1.getAvatar)(row === null || row === void 0 ? void 0 : row.media), alt: "illustration", className: "custom-image-table", "data-zoomable": true })))),
                (row === null || row === void 0 ? void 0 : row.media) && (row === null || row === void 0 ? void 0 : row.media_type) === "video" && (react_1.default.createElement("div", { className: "image__wrapper" },
                    react_1.default.createElement(react_medium_image_zoom_1.default, null,
                        react_1.default.createElement("video", { src: (0, Utils_1.getAvatar)(row === null || row === void 0 ? void 0 : row.media), controls: true, style: {
                                width: "200px",
                                height: "120px",
                                borderRadius: "4px",
                                objectFit: "cover",
                            } })))),
                (row === null || row === void 0 ? void 0 : row.media) && (row === null || row === void 0 ? void 0 : row.media_type) === "audio" && (react_1.default.createElement("div", { className: "image__wrapper" },
                    react_1.default.createElement(react_medium_image_zoom_1.default, null,
                        react_1.default.createElement("audio", { src: (0, Utils_1.getAvatar)(row === null || row === void 0 ? void 0 : row.media), controls: true, style: { width: "150px" } })))),
                (row === null || row === void 0 ? void 0 : row.content) && (react_1.default.createElement("div", { className: "d-flex flex-column gap-1" },
                    react_1.default.createElement("p", { className: "m-0", dangerouslySetInnerHTML: (0, Utils_1.createMarkup)((0, Utils_1.truncateString)(row === null || row === void 0 ? void 0 : row.content, 100)) }),
                    (row === null || row === void 0 ? void 0 : row.media_type) === "image" && (react_1.default.createElement("div", { className: "d-flex align-items-center gap-1" },
                        react_1.default.createElement("img", { src: "/images/icons/type.svg", alt: "illustration" }),
                        react_1.default.createElement("span", null, "Photo"))),
                    ((row === null || row === void 0 ? void 0 : row.media_type) === "video" ||
                        (row === null || row === void 0 ? void 0 : row.media_type) === "audio") && (react_1.default.createElement("div", { className: "d-flex align-items-center gap-1" },
                        react_1.default.createElement("img", { src: "/images/icons/type-2.svg", alt: "illustration" }),
                        react_1.default.createElement("span", null, "Vid\u00E9o / Audio"))))))));
    };
    const statutFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "statutformatter__wrapper" }, (row === null || row === void 0 ? void 0 : row.is_sended) === 1 ? (react_1.default.createElement("div", { className: "badge custom-badge-success" }, "D\u00E9livr\u00E9e")) : ((row === null || row === void 0 ? void 0 : row.status) === "nouveau" && (row === null || row === void 0 ? void 0 : row.is_sended) === 0) ? (react_1.default.createElement("div", { className: "badge custom-badge-in-progress" }, "Nouveau")) : (react_1.default.createElement("div", { className: "badge custom-badge-in-progress" }, row === null || row === void 0 ? void 0 : row.status))));
    };
    const segmentFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "statutformatter__wrapper" }, row === null || row === void 0 ? void 0 : row.segment.toUpperCase()));
    };
    const formatPublicationDate = (datetime) => {
        const moment = require("moment");
        moment.locale("fr");
        if (!datetime)
            return "";
        const now = moment();
        const date = moment(datetime);
        if (!date.isValid())
            return "";
        if (date.isSame(now, "day")) {
            return `Aujourd’hui - ${date.format("HH:mm")}`;
        }
        return (0, Utils_1.capitalize)(date.format("dddd D MMMM - HH:mm"));
    };
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "actionformatter__wrapper" },
            react_1.default.createElement(Dropdown_1.default, null,
                react_1.default.createElement(Dropdown_1.default.Toggle, { id: "dropdown-basic" },
                    react_1.default.createElement(bs_1.BsThreeDots, null)),
                react_1.default.createElement(Dropdown_1.default.Menu, null,
                    react_1.default.createElement(ShowNotificationButton, { item: row }),
                    react_1.default.createElement(EditNotificationButton, { item: row }),
                    react_1.default.createElement(Dropdown_1.default.Item, { onClick: () => handleDuplicate(row) }, "Dupliquer"),
                    react_1.default.createElement(DeleteNotificationButton, { id: row === null || row === void 0 ? void 0 : row.id }),
                    react_1.default.createElement(Dropdown_1.default.Item, { onClick: () => toggleArchiver(row) }, (row === null || row === void 0 ? void 0 : row.is_archive) === 0 ? "Archiver" : "Désarchiver"),
                    react_1.default.createElement(Dropdown_1.default.Item, { onClick: () => togglePublier(row) }, (row === null || row === void 0 ? void 0 : row.is_scheduled) === 1
                        ? "Publier"
                        : "Retirer de la publication")))));
    };
    const toggleSticky = (item) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const data = {
            is_sticked: item.is_sticked === 1 ? 0 : 1,
            scheduled_datetime: item === null || item === void 0 ? void 0 : item.scheduled_datetime,
            added_by: item === null || item === void 0 ? void 0 : item.added_by,
            categorie_id: item === null || item === void 0 ? void 0 : item.categorie_id,
            content: item === null || item === void 0 ? void 0 : item.content,
            direction_id: item === null || item === void 0 ? void 0 : item.direction_id,
            id: item === null || item === void 0 ? void 0 : item.id,
            is_scheduled: item.is_scheduled,
            media: item === null || item === void 0 ? void 0 : item.media,
            media_type: item === null || item === void 0 ? void 0 : item.media_type,
            segment: item === null || item === void 0 ? void 0 : item.segment,
            severity: item === null || item === void 0 ? void 0 : item.severity,
            slug: item === null || item === void 0 ? void 0 : item.slug,
            updated_at: item === null || item === void 0 ? void 0 : item.updated_at,
            _method: "PUT",
        };
        const action = data.is_sticked === 1 ? "mettre en avant" : "retirer de l'avant";
        const result = yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir ${action} cette notification ?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                try {
                    return yield editData({ id: item === null || item === void 0 ? void 0 : item.id, data });
                }
                catch (err) {
                    sweetalert2_1.default.showValidationMessage(((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message) ||
                        `Une erreur de statut ${(err === null || err === void 0 ? void 0 : err.status) || "inconnue"} est survenue`);
                    throw err;
                }
            }),
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        });
        if ((result === null || result === void 0 ? void 0 : result.isConfirmed) && ((_a = result === null || result === void 0 ? void 0 : result.value) === null || _a === void 0 ? void 0 : _a.data)) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `Notification ${result.value.data.data.is_sticked === 1
                    ? "mise en avant"
                    : "retirée de l'avant"} avec succès !`,
                iconColor: theme_1.Color.themeColor,
                showConfirmButton: false,
                timer: 1500,
            });
        }
    });
    const stickyFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "d-flex justify-content-start align-items-center" },
            react_1.default.createElement(react_switch_1.default, { checked: cell, onChange: () => toggleSticky(row), handleDiameter: 12, height: 18, width: 34, offHandleColor: "#4B4B4B", onHandleColor: "#0288D1", offColor: "#F9FAFB", onColor: "#F9FAFB", uncheckedIcon: false, checkedIcon: false, boxShadow: "none", activeBoxShadow: "none", className: "custom-switch", id: "custom-switch-id" })));
    };
    const [duplicateNotif] = (0, notification_api_1.useDuplicateNotificationMutation)();
    const handleDuplicate = (notif) => __awaiter(void 0, void 0, void 0, function* () {
        if (!(notif === null || notif === void 0 ? void 0 : notif.id)) {
            sweetalert2_1.default.fire({
                icon: "error",
                title: "Aucune notification à dupliquer.",
                showConfirmButton: false,
                timer: 1500,
            });
            return;
        }
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir dupliquer cette notification ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            if (result.isConfirmed) {
                try {
                    yield duplicateNotif(notif.id).unwrap();
                    sweetalert2_1.default.fire({
                        icon: "success",
                        title: "Notification dupliquée avec succès!",
                        iconColor: theme_1.Color.success,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
                catch (error) {
                    sweetalert2_1.default.fire({
                        icon: "error",
                        title: ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message) ||
                            "Erreur lors de la duplication.",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
            }
        }));
    });
    const columns = [
        {
            dataField: "titre",
            text: "Titre",
            formatter: titreFormatter,
            headerStyle: () => {
                return {
                    width: "260px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "scheduled_datetime",
            text: "Date de publication",
            formatter: (cell, row) => {
                const dateToFormat = row.is_scheduled === 1
                    ? row.scheduled_datetime
                    : row.created_at;
                return formatPublicationDate(dateToFormat);
            },
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "vues",
            text: "Vues",
            headerStyle: () => {
                return {
                    width: "100px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "status",
            text: "Statut",
            formatter: statutFormatter,
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "categorie.name",
            text: "Type",
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "segment",
            text: "Segment",
            formatter: segmentFormatter,
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "is_sticked",
            text: "À LA UNE",
            formatter: stickyFormatter,
            headerStyle: () => {
                return {
                    width: "100px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
        !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "col-lg-12" },
                react_1.default.createElement("div", { className: "admin-table" },
                    react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: paginatedData || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9es trouv\u00E9es" })) }),
                    react_1.default.createElement("div", { className: "custom-pagination-container" },
                        react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: filteredData === null || filteredData === void 0 ? void 0 : filteredData.length, page: page, onChange: (page, perPage) => {
                                setPerPage(perPage);
                                setPage(page);
                            }, perPage: perPage }))))))));
};
exports.default = NotificationsProgrammeesTable;
